module.exports = __webpack_public_path__ + "static/media/lose.4ab0b019.wav";